<template>
  <div>
    <div class="query-btn-area">
      <el-button type="success" class="queryBtn" @click="queryHandel">網上查詢申請狀況</br> Online Application Status Enquiry
      </el-button>
    </div>
    <!-- <div class="form-title"> 
      2024 年度申請登記表格</br> 【注意事項 Precaution】</br>
      在任何步驟重新整理瀏覽器將重返本頁重頭開始</br>
      Refreshing the browser at any step will return to this page and start over.
    </div>

    <div class="form-content">
      申請人於申請前必須細閱申請須知及申請參考片段，如因資料不足或錯誤而引致未能完成申請，本會概不負責。<br>Applicants must read the application guide and application
      reference videos before application. We will not be response for any failure to complete the application due to
      insufficient information or errors.<br>除非另有說明，於填寫申請表時，申請人可選擇以中文或英文填寫申請表。 申請人應確保使用相同的語言，完整填寫及提交申請表，並確保所提供的資料準確無誤。
      如果申請人未能準確提供申請表中要求的所有資料，其申請將不獲考慮。<br>Unless otherwise specified, applicants may choose to complete the online
      application form in either Chinese or English. Applicants should ensure that he/she is using the same language to
      complete the online application form in full and the information provided is accurate. Application may not be
      considered if applicant fails to accurately provide all information requested in the online application
      form.<br><br>網上申請開始時間：2023年10月24日下午三時<br>Online Application opening time: 3:00 p.m. on 24 October
      2023<br><br>若選擇繼續未完成之申請，需以登記電郵開啟草稿。<br>If you choose to continue your application, you need to open the draft with
      your registered email.<br>建議操作系統及互聯網瀏覽器<br>Recommended combinations of operation system / internet web
      browser<br>Internet Explorer 11/Google Chrome 71 (Microsoft Windows), Safari 10 (MacOS), Google Chrome 70
      (Android), Safari (iOS 12)
    </div> -->

    <div class="context-area">
      <div class="form-content " v-html="precautionContent"></div>
      <div class="form-content">
        <el-checkbox v-model="checked">本人已閱讀、明白及同意上述細則。<br>I understand and agree with all clauses in this statement.
        </el-checkbox></br>
      </div>
      <el-row :gutter="10" class="btn-box form-area">
        <el-button type="warning" class="index-btn" disabled="disabled" @click="newApply" round>新申請
          </br>New
          Application</el-button>
        <el-button type="warning" class="index-btn" disabled="disabled" @click="continueApply" round>
          繼續未完成申請
          </br>Continue Application
        </el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
  import {
    getContent
  } from "@/assets/js/api.js";
  export default {
    created() {
      getContent('PH20002').then(res => {
        console.log(res)
        this.precautionContent = res.context
      })
    },
    data() {
      return {
        checked: false,
        precautionContent: "" //注意事项内容
      };
    },
    methods: {
      queryHandel() {
        this.$store.dispatch("setSeptInfo", {
          k: "currentStepName",
          v: "query"
        });
        this.$store.dispatch("setSeptInfo", {
          k: "currentOperateName",
          v: "queryCondiction",
        });
      },
      newApply() {
        this.$store.dispatch("NEXT_STEP", {
          changeStep: false,
          operateName: "emailQuery",
        });
      },
      /**
       * 继续填写申请
       */
      continueApply() {
        this.$store.dispatch("setSeptInfo", {
          k: "currentStepName",
          v: "continue",
        });
        this.$store.dispatch("setSeptInfo", {
          k: "currentStepNum",
          v: 2,
        });
        this.$store.dispatch("setSeptInfo", {
          k: "currentOperateName",
          v: "emailQuery",
        });
      },
    },
  };

</script>

<style>
  .index-btn {
    width: 172px;
    margin: 0 40px;
    line-height: 16px;
    font-weight: 500;
  }

  .context-area {
    margin-top: 20px;
    font-family: 'IBM Plex Sans', 'Segoe UI', Arial, sans-serif !important;
    padding: 40px 0 0 5%;
    /* width: 100%; */
  }

</style>



// WEBPACK FOOTER //
// src/view/apply/index.vue